import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import PropTypes from "prop-types";
import xlsbg from "../assets/xlsbg.png";
import xlsbg800 from "../assets/xlsbg-800.png";
import xlsbg400 from "../assets/xlsbg-400.png";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    maxWidth: "900px",
  },
  header: {
    background: "#ccc",
    width: "100%",
    height: "auto",
  },
  content: {
    display: "flex",
    border: "1px solid #c5c5c5",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    background: "#dfdfdf",
  },
});

const XLSWindow = ({ children }) => {
  const styles = useStyles();

  return (
    <div className={styles.root + " xlswindow-root"}>
      <img
        className={styles.header}
        alt="Excel header"
        src={xlsbg}
        srcSet={`${xlsbg400} 400w, ${xlsbg800} 800w, ${xlsbg} 1226w`}
        sizes="(max-width: 900px) 100vw, 900px"
      />
      <div className={styles.content}>{children}</div>
    </div>
  );
};

XLSWindow.propTypes = {
  children: PropTypes.node.isRequired,
};

export default XLSWindow;
